webpackJsonp([209010163271233],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/Astraeus/Documents/repos/website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/Astraeus/Documents/repos/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/Astraeus/Documents/repos/website/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/Astraeus/Documents/repos/website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/Astraeus/Documents/repos/website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/Astraeus/Documents/repos/website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/pr_facets.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _navigoat = __webpack_require__("./src/layouts/navigoat.js");
	
	var _navigoat2 = _interopRequireDefault(_navigoat);
	
	var _pr_page = __webpack_require__("./src/layouts/pr_page.js");
	
	var _pr_page2 = _interopRequireDefault(_pr_page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_navigoat2.default, { active_tab: 'projs' }),
	    _react2.default.createElement(_pr_page2.default, { title: 'FACETS',
	      paper_title: 'FACETS: Adaptive Local Exploration of Large Graphs',
	      authors: 'Robert Pienta, Minsuk Kahng, Zhiyuan Lin, Jilles Vreeken, Partha Talukdar, James Abello, Ganesj Parameswaran, and Duen Horng Chau',
	      abstract: 'Visualization is a powerful paradigm for exploratory data analysis. Visualizing large graphs, however, often results in excessive edges crossings and overlapping nodes. We propose a new scalable approach called FACETS that helps users adaptively explore large million-node graphs from a local perspective, guiding them to focus on nodes and neighborhoods that are most subjectively interesting to users. We contribute novel ideas to measure this interestingness in terms of how surprising a neighborhood is given the background distribution, as well as how well it matches what the user has chosen to explore. FACETS uses Jensen-Shannon divergence over information-theoretically optimized histograms to calculate the subjective user interest and surprise scores. Participants in a user study found FACETS easy to use, easy to learn, and exciting to use. Empirical runtime analyses demonstrated FACETS\u2019s practical scalability on large real-world graphs with up to 5 million edges, returning results in fewer than 1.5 seconds.',
	      paper_linky: '../data/17-sdm-facets-mage.pdf',
	      paper_img: '../imgs/projs/pr-facets-cj.png',
	      img_caption: '',
	      video_linky: '',
	      bibtex: '@inproceedings{pienta2017facets,\n                 title={FACETS: Adaptive Local Exploration of Large Graphs},\n                 author={Pienta, Robert and Kahng, Minsuk and Lin, Zhiyuan and Vreeken, Jilles and Talukdar, Partha and Abello, James and Parameswaran, Ganesh and Chau, Duen Horng},\n                 booktitle={Proceedings of the 2017 SIAM International Conference on Data Mining},\n                 pages={597--605},\n                 year={2017},\n                 organization={SIAM}\n               }'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pr-facets-js-a0a7ea9e7434762cf033.js